import { Message } from "@JohnLewisPartnership/jl-design-system/dist/components/message/v2/Message";
import { getReturnsExclusionsMessage } from "./utils/getReturnsExclusionsMessage";
import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import styles from "./ReturnsExclusions.module.scss";

type Props = {
  browsePageHierarchy: Array<{ categoryId: string }>;
};

export function ReturnsExclusions({ browsePageHierarchy }: Props) {
  const returnsExclusionsMessage =
    getReturnsExclusionsMessage(browsePageHierarchy);

  if (!returnsExclusionsMessage) return null;

  return (
    <Message
      type="information"
      dataTest="returns:exclusions-message"
      title={returnsExclusionsMessage.title}
      body={
        <>
          <p>{returnsExclusionsMessage.message}</p>
          <div className={styles.buttonWrapper}>
            <UnderlinedButton
              tag="a"
              data-testid="returns:policy-link"
              className={styles.button}
              href="https://www.johnlewis.com/customer-services/returns?dt=informationOnOurReturnsPolicy"
            >
              Read our returns policy
            </UnderlinedButton>
          </div>
        </>
      }
    />
  );
}
